module.exports = __webpack_public_path__ + "media/images/btn_twitter-968ce93cfac293932fa625e58138af75.png";